import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

/**
 * Tiny loading spinner primitive (added in U9 to replace Fluent's <Spinner>).
 *
 * Wraps lucide's Loader2 with `animate-spin`. Pass `label` to render an
 * accompanying line of text (matches Fluent's `<Spinner label=... />`), and
 * `size` to control the icon dimensions (pixels).
 */
export interface SpinnerProps {
  className?: string
  /** Optional text shown to the right of the spinner. */
  label?: string
  /** Icon size in pixels. Defaults to 20. */
  size?: number
}

export function Spinner({ className, label, size = 20 }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={label ?? "Loading"}
      className="flex items-center justify-center gap-2 text-muted-foreground"
    >
      <Loader2
        className={cn("animate-spin text-accent-text", className)}
        style={{ width: size, height: size }}
      />
      {label ? <span className="text-sm">{label}</span> : null}
    </div>
  )
}
